// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import * as bootstrap from "bootstrap";
import LocalTime from "./helpers/local-time";

// Trix/ActionText e Chartkick não entram aqui: vêm em chunks pelos controllers "trix" e
// "chartkick" (controllers/index.js), só nas páginas que os usam.

import "./theme/app";

LocalTime.start();

document.addEventListener(
  "turbo:load",
  function (event) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-Q6EN39K6LP", { page_location: event.detail.url });
  },
  false
);
